import {BaseApi} from "./baseService";
import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {ConfigService} from "./configService";
import {Location} from '@angular/common';
import {Router} from "@angular/router";

const dpExtend = require("deep-extend");

declare var gtag: any;
declare var dataLayer: any;

@Injectable()
export class GoogleTagService extends BaseApi {

    public eventsArray: string[] = [];

    public constructor(private location: Location, protected http: Http, protected configService: ConfigService, private router: Router) {
        super(http, configService);
    }

    public pushData(location: string, customData: any | null = null): void {
        const path = `calculator2/public/${location}`;

        if(!this.eventsArray.includes(location)) {
           if (location === 'import' && !this.eventsArray.includes(location))
               this.eventsArray.push('import');

            this.location.replaceState(this.buildUrl(this.router, {}, path, true));

            if (customData){
                dataLayer.push(customData);
            }else {
                dataLayer.push({'page_path': path, event: 'virtualPageView'});
            }

            gtag('config', this.configService.config.GUATagId ? this.configService.config.GUATagId : this.configService.config.GTagId, {
                'page_title': path,
                'page_path': `/${path}`
            });
        }
    }

    public clearEventsArray(): void {
        this.eventsArray = [];
    }

    private getRoot(router: Router) {
        return router.url.split('?')[0];
    }

    private buildUrl(router: Router, queryString: object, root: string = "", preserveQueryString: boolean = false) {
        if (preserveQueryString) {
            let obj = {};
            dpExtend(obj, router.routerState.snapshot.root.queryParams);
            if(queryString){
                dpExtend(obj, queryString);
            }
            queryString = obj;
        }

        if (String.isNullOrEmpty(root))
            root = this.getRoot(router);

        return router.createUrlTree([root], {
            queryParams: queryString
        }).toString()
    }
}



// WEBPACK FOOTER //
// ./app/services/google-tag.service.ts